function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { listMine, withdraw, urge } from '@/api/approval';
import Cookies from 'js-cookie';
export default {
  name: 'MyApproval',
  data: function data() {
    return {
      list: [],
      loading: false,
      filter: {
        bizType: '',
        status: ''
      },
      urgingId: null
    };
  },
  computed: {
    userId: function userId() {
      // 从 Cookie 读, 由 store/user.js 在 getInfo 时写入
      return Cookies.get('JavaAdminId_copy');
    },
    filtered: function filtered() {
      var _this = this;
      return this.list.filter(function (r) {
        if (_this.filter.bizType && !(r.businessType || '').includes(_this.filter.bizType)) return false;
        if (_this.filter.status !== '' && _this.filter.status !== null && r.status !== _this.filter.status) return false;
        return true;
      });
    }
  },
  created: function created() {
    this.load();
  },
  methods: {
    load: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.userId) {
                _context.n = 1;
                break;
              }
              this.$message.warning('未获取到登录信息');
              return _context.a(2);
            case 1:
              this.loading = true;
              _context.p = 2;
              _context.n = 3;
              return listMine(this.userId);
            case 3:
              res = _context.v;
              data = res && (res.data !== undefined ? res.data : res);
              this.list = Array.isArray(data) ? data : [];
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.$message.error('加载失败: ' + (_t.message || _t));
              this.list = [];
            case 5:
              _context.p = 5;
              this.loading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }(),
    statusType: function statusType(row) {
      if (row.status === 0) return 'primary';
      if (row.result === 0) return 'success';
      if (row.result === 1) return 'danger';
      return 'info';
    },
    statusText: function statusText(row) {
      if (row.status === 0) return '审批中';
      if (row.result === 0) return '已通过';
      if (row.result === 1) return '已驳回';
      return '已撤回';
    },
    goDetail: function goDetail(row) {
      this.$router.push("/approval/detail/".concat(row.id));
    },
    /** 催办：提醒当前审批人。后端有 30 分钟冷却，重复点会被挡回并提示 */urgeRow: function () {
      var _urgeRow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var _this2 = this;
        var who;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              who = row.currentAssigneeName || '当前审批人';
              this.$confirm("\u786E\u5B9A\u50AC\u529E ".concat(who, " \u5904\u7406\u300C").concat(row.title, "\u300D?"), '催办', {
                type: 'info'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                var res, msg, _t2;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.p = _context2.n) {
                    case 0:
                      _this2.urgingId = row.id;
                      _context2.p = 1;
                      _context2.n = 2;
                      return urge(row.id, _this2.userId);
                    case 2:
                      res = _context2.v;
                      msg = res && (res.data !== undefined ? res.data : res);
                      _this2.$message.success(typeof msg === 'string' && msg ? msg : '已催办');
                      _this2.load();
                      _context2.n = 4;
                      break;
                    case 3:
                      _context2.p = 3;
                      _t2 = _context2.v;
                      _this2.$message.warning('催办失败: ' + (_t2.message || _t2));
                    case 4:
                      _context2.p = 4;
                      _this2.urgingId = null;
                      return _context2.f(4);
                    case 5:
                      return _context2.a(2);
                  }
                }, _callee2, null, [[1, 3, 4, 5]]);
              }))).catch(function () {});
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function urgeRow(_x) {
        return _urgeRow.apply(this, arguments);
      }
      return urgeRow;
    }(),
    withdrawRow: function () {
      var _withdrawRow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var _this3 = this;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.$confirm('确定撤回该申请?撤回后可修改后重新提交。', '提示', {
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                var _t3;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.p = _context4.n) {
                    case 0:
                      _context4.p = 0;
                      _context4.n = 1;
                      return withdraw(row.id, _this3.userId);
                    case 1:
                      _this3.$message.success('已撤回');
                      _this3.load();
                      _context4.n = 3;
                      break;
                    case 2:
                      _context4.p = 2;
                      _t3 = _context4.v;
                      _this3.$message.error('撤回失败: ' + (_t3.message || _t3));
                    case 3:
                      return _context4.a(2);
                  }
                }, _callee4, null, [[0, 2]]);
              }))).catch(function () {});
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function withdrawRow(_x2) {
        return _withdrawRow.apply(this, arguments);
      }
      return withdrawRow;
    }(),
    editRejected: function editRejected(row) {
      // 根据 businessType 跳到原始业务的编辑页
      var bizMap = {
        '商户新增商品': "/product/creatProduct/".concat(row.businessId, "?editOrCopy=edit"),
        '商户修改商品': "/product/creatProduct/".concat(row.businessId, "?editOrCopy=edit")
      };
      var path = bizMap[row.businessType];
      if (path) this.$router.push(path);else this.$message.info('该业务类型暂不支持一键跳转,请在对应页面手动修改');
    }
  }
};